// import { useWatch } from "react-hook-form";
import { StyledTextArea } from "src/components";

const AdminComment = ({ item, control, onChange }) => {
  //   const value = useWatch({
  //     control,
  //     name: `${area}.${questionKey}.score`,
  //   });

  const { area, key } = item;

  if (
    // ((value === undefined || value === "n/a") &&
    //   (item["admin-score"] === undefined || item["admin-score"] === "n/a")) ||
    !area
  )
    return null;

  return (
    <div className="mb-3">
  
      <StyledTextArea
        className="mt-2"
        defaultValue={item.adminComment}
        name={`${area}.${key}.adminComment`}
        onChange={onChange}
        placeholder="Admin comment"
      />
    </div>
  );
};

export default AdminComment;
